<template>
  <div class="home p-col-12">
    <h1>Сервис генерации КП</h1>
  </div>
</template>
